import React, { useEffect, useState } from "react";
import { Grid, GridRow, GridColumn, SearchBox, Stack, ClearFiltersButton, ListTable } from "sprint-common-web";

import { useAssetsApi } from "../../../common/api/master-api/assets/useAssetsApi";
import { createLookupCloudAssetsListTableColumns } from "./createLookupCloudAssetsListColumns";
import { LookupCloudAssetItem, mapToLookupCloudAssetItem } from "./LookupCloudAssetItem";

interface LookupCloudAssetsListProps {
    onClick: (item: LookupCloudAssetItem) => void;
}

export const LookupCloudAssetsList = ({ onClick }: LookupCloudAssetsListProps): JSX.Element => {
    const { getCloudAssetsLookup } = useAssetsApi();

    const [items, setItems] = useState<LookupCloudAssetItem[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [isLoadingList, setIsLoadingList] = useState(false);
    const [filters, setFilters] = useState({
        buzzId: "",
        page: 1,
        pageSize: 10
    });

    useEffect(() => {
        setIsLoadingList(true);
        getCloudAssetsLookup(filters)
            .then((res) => {
                setItems(res.items.map(mapToLookupCloudAssetItem));
                setTotalItems(res.totalCount);
            })
            .finally(() => {
                setIsLoadingList(false);
            });
    }, [filters]);

    const setBuzzId = (buzzId: string) => {
        setFilters((prev) => ({ ...prev, buzzId, page: 1 }));
    };

    const setPage = (page: number) => {
        setFilters((prev) => ({ ...prev, page }));
    };

    const clearFilters = () => {
        setFilters({ buzzId: "", page: 1, pageSize: 10 });
    };

    const columns = createLookupCloudAssetsListTableColumns({ onClick });

    return (
        <Grid>
            <GridRow>
                <GridColumn sm={6}>
                    <SearchBox
                        testId="assets-lookup-search-buzz-id"
                        placeholder="Buzz Id"
                        onChange={setBuzzId}
                        value={filters.buzzId}
                    />
                </GridColumn>

                <GridColumn sm={6}>
                    <Stack horizontalAlign="end">
                        <ClearFiltersButton onClear={clearFilters} isLabeled={true} />
                    </Stack>
                </GridColumn>
            </GridRow>

            <GridRow>
                <GridColumn sm={12} style={{ height: 500, overflowY: "auto" }}>
                    <ListTable
                        columns={columns}
                        items={items}
                        layoutMode="justified"
                        isLoading={isLoadingList}
                        shimmerLines={3}
                        pagination={{
                            page: filters.page,
                            pageSize: filters.pageSize,
                            totalItems,
                            onPageChange: setPage
                        }}
                        noItemsMessage={
                            !filters.buzzId
                                ? "Search for cloud assets by entering a Buzz Id of a content or version."
                                : "Could not match any cloud assets with the provided buzz Id."
                        }
                    />
                </GridColumn>
            </GridRow>
        </Grid>
    );
};
